import localeText from "../../../../../../locale";

const SecurityValidationHeader = ({ onClose, disabled }) => (
  <div className="security-validation-header">
    <div className="security-validation-header-title">
      <div
        className="flex align-items-center justify-content-center overflow-hidden"
        style={{
          border: "1px solid var(--theme-border, #E9ECEF)",
          borderRadius: "50%",
          padding: "0.5rem",
        }}
        aria-hidden="true"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 0L11.4735 1.71C11.6262 1.75766 11.7596 1.85286 11.8543 1.98172C11.949 2.11057 12.0001 2.26633 12 2.42625V3.75H13.5C13.6989 3.75 13.8897 3.82902 14.0303 3.96967C14.171 4.11032 14.25 4.30109 14.25 4.5V6H4.5V4.5C4.5 4.30109 4.57902 4.11032 4.71967 3.96967C4.86032 3.82902 5.05109 3.75 5.25 3.75H10.5V2.9775L6 1.5705L1.5 2.9775V8.5305C1.49989 8.98967 1.60519 9.44274 1.80777 9.8548C2.01036 10.2669 2.30483 10.6269 2.6685 10.9072L2.81025 11.0093L6 13.185L8.8365 11.25H5.25C5.05109 11.25 4.86032 11.171 4.71967 11.0303C4.57902 10.8897 4.5 10.6989 4.5 10.5V7.5H14.25V10.5C14.25 10.6989 14.171 10.8897 14.0303 11.0303C13.8897 11.171 13.6989 11.25 13.5 11.25L11.085 11.2507C10.7948 11.6332 10.4422 11.9707 10.035 12.2482L6 15L1.965 12.249C1.35939 11.8361 0.863814 11.2815 0.521355 10.6334C0.178896 9.98538 -7.59171e-05 9.26348 2.41574e-08 8.5305V2.42625C9.04547e-05 2.26646 0.051215 2.11087 0.145922 1.98216C0.240628 1.85346 0.373966 1.75837 0.5265 1.71075L6 0Z"
            fill="var(--theme-text-muted, #5C5C5C)"
          />
        </svg>
      </div>
      <h2 className="text-lg font-medium">{localeText("securityValidationTitle")}</h2>
    </div>
    <button
      type="button"
      className="security-validation-close"
      onClick={onClose}
      disabled={disabled}
      aria-label={localeText("close")}
    >
      <i className="pi pi-times text-xs" />
    </button>
  </div>
);

export default SecurityValidationHeader;
